import { useTranslation } from 'react-i18next'
import { MarketingPage } from '@/components/marketing/marketing-page'
import { ProseSection, ProseParagraphs } from '@/components/marketing/prose-section'
import { MarketingCta } from '@/components/marketing/marketing-cta'
import { RelatedLinks } from '@/components/marketing/related-links'
import { buildRelatedLinks } from '@/components/marketing/links'
import { arrayKey } from '@/components/marketing/i18n-array'
import { JsonLd } from '@/components/seo/json-ld'
import { breadcrumbSchema, articleSchema } from '@/components/marketing/marketing-schema'

const KEY = 'visualResearchTool'
const PATH = '/visual-research-tool'

export function VisualResearchToolPage() {
  const { t, i18n } = useTranslation()
  const section = (name: string) => arrayKey(t, `marketing.${KEY}.${name}.body`)

  return (
    <MarketingPage
      seoTitle={t(`marketing.${KEY}.seo.title`)}
      seoDescription={t(`marketing.${KEY}.seo.description`)}
      path={PATH}
      eyebrow={t(`marketing.${KEY}.eyebrow`)}
      heading={t(`marketing.${KEY}.h1`)}
      lead={t(`marketing.${KEY}.lead`)}
    >
      <JsonLd data={breadcrumbSchema(KEY)} />
      <JsonLd
        data={articleSchema({
          headline: t(`marketing.${KEY}.h1`),
          description: t(`marketing.${KEY}.seo.description`),
          path: PATH,
          language: i18n.language,
        })}
      />

      <ProseSection title={t(`marketing.${KEY}.linearProblem.title`)}>
        <ProseParagraphs paragraphs={section('linearProblem')} />
      </ProseSection>
      <ProseSection title={t(`marketing.${KEY}.canvas.title`)}>
        <ProseParagraphs paragraphs={section('canvas')} />
      </ProseSection>
      <ProseSection title={t(`marketing.${KEY}.advantages.title`)}>
        <ProseParagraphs paragraphs={section('advantages')} />
      </ProseSection>
      <ProseSection title={t(`marketing.${KEY}.howMindweb.title`)}>
        <ProseParagraphs paragraphs={section('howMindweb')} />
      </ProseSection>

      <MarketingCta
        title={t(`marketing.${KEY}.cta.title`)}
        body={t(`marketing.${KEY}.cta.body`)}
        buttonLabel={t(`marketing.${KEY}.cta.button`)}
        to="/"
      />
      <RelatedLinks
        heading={t('marketing.common.relatedHeading')}
        links={buildRelatedLinks(t, KEY, [
          'aiKnowledgeGraphGenerator',
          'deepResearchAiTool',
          'whatIsKnowledgeGraph',
        ])}
      />
    </MarketingPage>
  )
}
